import { useState } from 'react';
import { Receipt } from 'lucide-react';
import ScanFactureFournisseurDialog from '@/components/ScanFactureFournisseurDialog';
import { usePermissions } from '@/contexts/PermissionsContext';

/**
 * Bouton flottant pour scanner une facture fournisseur (visible si l'user a accès aux factures).
 */
export default function ScanFactureButton() {
  const [open, setOpen] = useState(false);
  const { isModuleBlocked } = usePermissions();

  if (isModuleBlocked('factures') || isModuleBlocked('comptabilite')) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-56 right-4 md:bottom-44 md:right-8 z-50 w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white shadow-lg flex items-center justify-center transition-all hover:scale-110"
        title="Scanner justificatif (facture, ticket, péage…)"
        data-testid="scan-facture-fab"
      >
        <Receipt className="w-6 h-6" />
      </button>
      <ScanFactureFournisseurDialog
        open={open}
        onClose={() => setOpen(false)}
        onCreated={() => setOpen(false)}
      />
    </>
  );
}
